<mat-form-field color="primary" class="single-date-time-range-picker w-[320px]" [formGroup]="dateTimeForm">
    <mat-label></mat-label>
    <div class="flex items-center w-fit !bg-inherit justify-center">
        <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="this.isDatePickerDisabled()" [id]="'singleDateRangePicker'" />
        @if (!this.value && this.hideEmptyValues) {
            <span class="!text-[#71787E]" i18n>No range set</span>
        }
        <div [hidden]="!this.value && this.hideEmptyValues">
            <mat-date-range-input formGroupName="date" [rangePicker]="picker" class="!text-[#71787E] !bg-inherit">
                <input matStartDate readonly formControlName="startDate" placeholder="Start date" >
                <input matEndDate readonly formControlName="endDate" placeholder="End date"   >
            </mat-date-range-input>
        </div>
    </div>
    <mat-date-range-picker #picker panelClass="!w-[394px] !h-[390px] !text-base date-time-range-picker" [disabled]="this.isDatePickerDisabled()" >
        <mat-date-range-picker-actions class="flex !flex-col">
            <div class="h-[130px] flex items-center pt-[25px]">
                <lib-time-range-picker 
                [parentFormGroup]="dateTimeRangeService.getTimeFormGroup()"
                containerClass="gap-[22px] w-[394px]"/>
            </div>
            <div>
                @if (getErrorMessage()) {
                    <mat-error class="!flex pl-2 max-w-[296px]">
                        {{getErrorMessage()}}
                    </mat-error>
                }
            </div>
            <div class="solid"></div>
            <div class="flex self-end gap-[7px] h-[60px] pr-[8px] action-buttons">
                <button mat-button matDateRangePickerCancel (click)="onCancel($event)"
                    class="text-sm font-medium" [disabled]="shouldDisableCancelButton()" i18n>Cancel</button>
                <button mat-button matDateRangePickerApply (click)="onSubmit($event)"
                    class="text-sm font-medium" [disabled]="shouldDisableApplyButton()" i18n>Apply</button>
            </div>
        </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field>